module.exports = __webpack_public_path__ + "img/onboarding-step-7-ir.692954a3.png";